var _mask, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 51,
  height: 51,
  viewBox: "0 0 51 51",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 51,
  height: 51
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.802612 0.802734H50.1852V50.1851H0.802612V0.802734Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.494 48.2094C12.9488 48.2094 2.77795 38.0386 2.77795 25.4934C2.77795 12.9472 12.9488 2.77734 25.494 2.77734C38.0392 2.77734 48.2101 12.9472 48.2101 25.4934C48.2101 38.0386 38.0392 48.2094 25.494 48.2094ZM25.494 0.802734C11.8564 0.802734 0.802612 11.8566 0.802612 25.4941C0.802612 39.1306 11.8564 50.1855 25.494 50.1855C39.1305 50.1855 50.1853 39.1306 50.1853 25.4941C50.1853 11.8566 39.1305 0.802734 25.494 0.802734Z",
  fill: "#3e5660"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.4939 13.6416C26.5847 13.6416 27.4692 14.5261 27.4692 15.6169C27.4692 16.7077 26.5847 17.5922 25.4939 17.5922C24.4031 17.5922 23.5186 16.7077 23.5186 15.6169C23.5186 14.5261 24.4031 13.6416 25.4939 13.6416Z",
  fill: "#3e5660"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.5186 39.3207H27.4692V21.543H23.5186V39.3207Z",
  fill: "#3e5660"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info.4e687f7bde98a374ca3b3dbdb45c0ddf.svg";